export default __webpack_public_path__ + "static/media/bg-video.685adf8e.mp4";